<h2 mat-dialog-title>Session no longer valid</h2>
<mat-dialog-content><p>Your session is no longer valid. Please log out and sign in again.</p></mat-dialog-content>
<mat-dialog-actions align="end">
  <button
    matButton
    ccsButton="primary"
    type="button"
    (click)="acknowledgeSession()">
    Log out
  </button>
</mat-dialog-actions>
